var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrmAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 15C19.6 16.68 18.28 18 16.6 18C15.46 18 14.5 17.4 13.96 16.44V16.38L7.42 4.5C7.12 4.02 7 3.54 7 3C7 1.32 8.32 0 10 0C11.14 0 12.1 0.6 12.64 1.56V1.62L19.18 13.56C19.48 13.98 19.6 14.46 19.6 15Z",
    fill: "#0284FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03641 16.3801C6.27641 15.9601 6.39641 15.4801 6.39641 15.0001C6.39641 13.3201 5.07641 12.0001 3.39641 12.0001C2.25641 12.0001 1.29641 12.6001 0.816406 13.5001L7.35641 1.62012C7.11641 2.04012 6.99641 2.52012 6.99641 3.00012C6.99641 3.54012 7.11641 4.02012 7.35641 4.44012L9.93641 9.18012L6.03641 16.3801Z",
    fill: "#FCBD02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39844 18C5.05529 18 6.39844 16.6569 6.39844 15C6.39844 13.3431 5.05529 12 3.39844 12C1.74158 12 0.398438 13.3431 0.398438 15C0.398438 16.6569 1.74158 18 3.39844 18Z",
    fill: "#03A846"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmAds);
export default __webpack_public_path__ + "static/media/crm-ads.87a7f759966e96107bec16de3c7b1edd.svg";
export { ForwardRef as ReactComponent };